import script from "./ImpressumPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImpressumPage.vue?vue&type=script&setup=true&lang=ts"

import "./ImpressumPage.vue?vue&type=style&index=0&id=5fe88c75&scoped=true&lang=css"

import exportComponent from "../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fe88c75"]])

export default __exports__